/**
 * Die unterschiedlichen Typen, die ein Zertifikat haben kann.
 *
 * Aktuell werden die nur zur Unterscheidung verwendet, wie ein Enum. Später
 * könnten wir daran auch weitere Informationen knüpfen.
 */
export const CERT_TYPES = {
  user: Object.freeze({ name: "user" }),
  pseudonym: Object.freeze({ name: "pseudonym" }),
  group: Object.freeze({ name: "group" }),
  server: Object.freeze({ name: "server" }),
  pkcs10: Object.freeze({ name: "pkcs10" }),
};
